import React from 'react';
import {Checkbox, Flex} from "antd";
import {t} from "i18next";
import FilterItemsTitle from "./FilterItemsTitle";

interface CompareFilterProps {
  selectedMetrics: Array<keyof DataType>,
  setSelectedMetrics: Function,
}

interface DataType {
  budget: string,
  cac: string,
  kpi: string,
  kpi_long_term: string,
  kpi_short_term: string,
  roas: string,
}

const metrics: Array<keyof DataType> = [
  'kpi', 'budget', 'roas', 'kpi_short_term', 'kpi_long_term',
];

const getMetricName = (metric: string) => {
  switch (metric) {
    case 'kpi':
      return t('planner.kpiInTotals');
    case 'kpi_long_term':
      return t('planner.kpiLongTerm');
    case 'kpi_short_term':
      return t('planner.kpiShortTerm');
    case 'cac':
      return t('planner.cac');
    case 'budget':
      return t('planner.budget');
    case 'roas':
      return t('planner.roas');
    default:
      return ''
  }
};

export default function CompareFilter({selectedMetrics, setSelectedMetrics}: CompareFilterProps) {
  return (
    <>
      <Flex className={'compare-filter__title'}>{t('planner.selectFilterItems')}</Flex>
      <Flex vertical gap={6} justify={'center'}>
        <Flex className={'compare-filter__block'} vertical gap={'small'} justify={'center'}>
          <FilterItemsTitle title={t('planner.metricsName')} count={metrics.length}/>
          <Flex vertical gap={2}>
            {metrics.map(metric => (
              <Flex className={'compare-filter__item'} gap={'small'}>
                <Checkbox
                  checked={selectedMetrics.includes(metric)}
                  onChange={(event) => {
                    if (event.target.checked) {
                      setSelectedMetrics([
                        ...selectedMetrics,
                        metric,
                      ])
                    } else {
                      setSelectedMetrics([...selectedMetrics.filter(function (value, index, arr) {
                        return value !== metric
                      })])
                    }
                  }}
                />
                {getMetricName(String(metric))}
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
